<script lang="ts">
    import PreviousIcon from '../icons/PreviousIcon.svelte';
    import NextIcon from '../icons/NextIcon.svelte';

    export let totalItems: number;
    export let currentPage: number;
    export let onPageChange: (page: number) => void;
    export let itemsPerPage: number = 10; // Default is 10

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    function changePage(newPage: number) {
        if (newPage >= 1 && newPage <= totalPages) {
            onPageChange(newPage);
        }
    }
</script>

{#if totalPages > 1}
    <div class="flex justify-center mt-6">
        <div class="flex items-center gap-2">
            <!-- Previous button -->
            <button
                    class="w-[30px] h-[30px] flex items-center justify-center border-none bg-transparent cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed
                hover:bg-gray-200 active:bg-gray-300"
                    on:click={() => changePage(currentPage - 1)}
                    disabled={currentPage === 1}
                    aria-label="Previous Page"
            >
                <PreviousIcon/>
            </button>

            <!-- Page buttons -->
            {#each Array(totalPages).fill(0).map((_, index) => index + 1) as page}
                <button
                        class={`w-[38px] h-[39px] flex items-center justify-center rounded-[3px] text-[16px] cursor-pointer border-none
                    ${page === currentPage
                        ? 'bg-gray-300' // Keep active state gray
                        : 'hover:bg-gray-200 active:bg-gray-300'}
                    `}
                        on:click={() => changePage(page)}
                        aria-label={`Page ${page}`}
                >
                    {page}
                </button>
            {/each}

            <!-- Next button -->
            <button
                    class="w-[30px] h-[30px] flex items-center justify-center border-none bg-transparent cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed
                hover:bg-gray-200 active:bg-gray-300"
                    on:click={() => changePage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    aria-label="Next Page"
            >
                <NextIcon/>
            </button>
        </div>
    </div>
{/if}